function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1615 7.87113L12.9281 5.158L14.7279 3.01307C15.1558 2.46926 15.2036 2.46918 15.7168 2.92903L17.8724 4.73778C18.3974 5.18468 18.4283 5.17409 17.9613 5.7262L16.1615 7.87113ZM9.41225 15.9146C8.30581 14.9853 6.4925 13.4646 6.17887 13.2015L12.0282 6.23046L15.2616 8.94359L9.41225 15.9146ZM4.53026 18.4495L5.27896 14.2739L8.51235 16.9871L4.53026 18.4495ZM19.3112 4.11751L16.0778 1.40438C15.4257 0.857229 14.6495 0.917724 14.1001 1.57246L4.10533 13.4838L3.08336 19.0794C2.98995 19.8517 3.41676 20.2099 4.16116 19.9838L9.4943 18.0057L19.4891 6.09435C20.0385 5.43961 19.9628 4.6652 19.3112 4.11751Z",
  fill: "#388000"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.f88663a8.svg";
export { ForwardRef as ReactComponent };